export const COMPONENT_COPY_SUFFIX = " (copy)";
export const UNIQUE_COMPONENT_NAME_BATCH_SIZE = 20;
export const UNIQUE_COMPONENT_NAME_MAX_SUFFIX = 200;

const CUSTOM_SHOPPABLE_CAROUSEL_TYPE = "links";

/** Identity / lifecycle fields that must not be copied onto a duplicated row. */
export const COMPONENT_DUPLICATE_OMIT = new Set([
  "id",
  "created_at",
  "updated_at",
  "status",
  "status_expiry",
  "start_date",
  "archive_date",
  "archived_at",
  "archive_index",
  "unique_id",
  "route_name",
  "index",
]);

export function isCustomShoppableCarousel(component: any) {
  return String(component?.type ?? "").trim() === CUSTOM_SHOPPABLE_CAROUSEL_TYPE;
}

export function buildComponentCopyName(
  originalName: unknown,
  suffix: string = COMPONENT_COPY_SUFFIX
) {
  const trimmed =
    typeof originalName === "string" ? originalName.trim() : "";
  return `${trimmed || "Untitled"}${suffix}`;
}

export function buildUniqueNameCandidates(
  desiredName: string,
  start: number,
  count: number
) {
  const names: string[] = [];
  for (let n = start; n < start + count; n += 1) {
    names.push(n <= 1 ? desiredName : `${desiredName} ${n}`);
  }
  return names;
}

/** Exact DB-style match (same as `.eq("name", name)` / `.in("name", ...)`). */
export function pickFirstAvailableName(
  candidates: string[],
  visibleTakenNames: Set<string>
) {
  return candidates.find((name) => !visibleTakenNames.has(name)) ?? null;
}

export function buildDuplicatedComponentPayload(
  source: Record<string, unknown>,
  {
    copyName,
    userId,
    index,
    uniqueSlug,
    pageId,
    includeRouteSlug,
  }: {
    copyName: string;
    userId: string;
    index: number;
    uniqueSlug?: string;
    pageId?: string | null;
    includeRouteSlug?: boolean;
  }
) {
  const payload: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(source || {})) {
    if (COMPONENT_DUPLICATE_OMIT.has(key)) continue;
    payload[key] = value;
  }

  payload.name = copyName;
  payload.user_id = userId;
  payload.status = "draft";
  payload.status_expiry = "draft";
  payload.start_date = null;
  payload.archive_date = null;
  payload.index = index;

  const sourceName =
    typeof source?.name === "string" ? source.name.trim() : "";
  const sourceDisplayName =
    typeof source?.display_name === "string" ? source.display_name.trim() : "";
  if (!sourceDisplayName || sourceDisplayName === sourceName) {
    payload.display_name = copyName;
  }

  if (includeRouteSlug && uniqueSlug) {
    payload.unique_id = uniqueSlug;
    payload.route_name = uniqueSlug;
  }
  if (pageId) {
    payload.page_id = pageId;
  }

  return payload;
}
